import React from "react";
import { Card, Row, Col, Button, Layout } from "antd";
import styles from "../../../styles/StandardFormLayout.module.scss";
import StandardContainerLayout from "../../../layouts/StandardContainerLayout";
import { useNavigate } from "react-router-dom";
const { Content } = Layout;

const UserDashboard = () => {
  const navigator = useNavigate();

  const onRedirect = (type) => {
    if(type === "timesheet"){
      navigator("/time-sheets");
    }else if(type === "safe-work-procedures-document"){
      navigator("/documents/safety-work-method-statements");
    }else if(type === "incident-report"){
      navigator("/incident-report");
    }else if(type === "complete-prestart"){
      navigator("/fleet/prestarts/completing/new");
    }
  };


  return (
    <StandardContainerLayout>
      <Content className={styles.dashboard__content}>
        <Row gutter={16}>
          <Col span={24}>
            <Card>
              <div style={{display: "flex", flexDirection: "column", gap: "10px"}}>
              <Button
                type="primary"
                size="large"
                block
                onClick={() => onRedirect("timesheet")}
              >
                Timesheet
                {/* Link to the timesheet page */}
              </Button>
              <Button
                type="primary"
                danger
                size="large"
                block
                onClick={() => onRedirect("safe-work-procedures-document")}
              >
                Safe Work Procedures
              </Button>
              <Button
                type="primary"
                size="large"
                block
                style={{
                  backgroundColor: '#fa8c16',
                  borderColor: '#fa8c16',
                  boxShadow: '0 2px 4px rgba(250, 140, 22, 0.2)'
                }}
                onClick={() => onRedirect("incident-report")}
              >
                Incident Report
                {/* Link to the timesheet page */}
              </Button>
              <Button
                type="primary"
                size="large"
                block
                style={{
                  backgroundColor: '#52c41a',
                  borderColor: '#52c41a',
                  boxShadow: '0 2px 4px rgba(82, 196, 26, 0.2)'
                }}
                onClick={() => onRedirect("complete-prestart")}
              >
                Complete Prestart
                {/* Link to the timesheet page */}
              </Button>
              </div>
              
            </Card>
          </Col>
          
        </Row>
      </Content>
    </StandardContainerLayout>
  );
};

export default UserDashboard;
